(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    /* --- MOBILE MENU TOGGLE LOGIC (OUTSIDE THE CLASS) --- */
    initMobileNav() {
      const selectors = '.togglesubmenu, .togglesubsubmenu';
      console.log('selectors', selectors);
      // Using event delegation on the body for maximum reliability
      document.body.addEventListener('click', function (e) {
        const target = e.target.closest(selectors);
        console.log(target);
        if (!target) return;

        e.preventDefault();
        e.stopPropagation();

        const parent = target.parentElement;
        const submenu = target.nextElementSibling;

        if (submenu) {
          // Toggle active class on parent for arrow rotation
          parent.classList.toggle('active');

          // Check current display and toggle it
          const isHidden = window.getComputedStyle(submenu).display === 'none';
          submenu.style.display = isHidden ? 'block' : 'none';
        }
      });
    }

    // Run on load
    // initMobileNav();
  }

  function initMobileNav() {
    const selectors = ' .togglesubsubmenu';
    console.log('selectors', selectors);
    // Using event delegation on the body for maximum reliability
    document.body.addEventListener('click', function (e) {
      const target = e.target.closest(selectors);
      console.log(target);
      if (!target) return;

      e.preventDefault();
      e.stopPropagation();

      const parent = target.parentElement;
      const submenu = target.nextElementSibling;

      if (submenu) {
        // Toggle active class on parent for arrow rotation
        parent.classList.toggle('active');

        // Check current display and toggle it
        const isHidden = window.getComputedStyle(submenu).display === 'none';
        submenu.style.display = isHidden ? 'block' : 'none';
      }
    });
  }

  initMobileNav();

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
